// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BUku","list":"styles_list__3Ht0D","disableSelection":"styles_disableSelection__QcTGF"};